// -----------------------------------------------------
// カートに商品を追加する前に実行する処理
// -----------------------------------------------------
function BeforeAddToCartBase() {
  return {
    /**
     * カートに商品を追加する前に実行する処理
     * @param {form} form - フォーム
     */
    isFormDisabled: function(form) {
      form.disabled = true;
      form.classList.add("disabled");
    },

    /**
     * カートに商品を追加する前に実行する処理
     * @param {button} btn - ボタン
     */
    isBtnDisabled: function(btn) {
      btn.disabled = true;
      btn.classList.add("disabled");
    }
  }
}

function YytBeforeAddToCart() {
  const { isFormDisabled, isBtnDisabled } = BeforeAddToCartBase();

  return {
    /**
     * カートに商品を追加する前に実行する処理（アニメーション開始）
     * @param {button} btn - ボタン
     */
    animationStart: function(btn) {
      if (!btn) return console.error("btn が存在しません");
      btn.innerHTML = "<span>追加中...</span>";
    },
    isBtnDisabled,
    isFormDisabled
  }
}

// -----------------------------------------------------
// カートに商品を追加した後に実行する処理
// -----------------------------------------------------
function AfterAddToCartBase() {
  return {
    /**
     * カートに商品を追加した後に実行する処理
     * @param {form} form - フォーム
     */
    isFormEnabled: function(form) {
      form.disabled = false;
      form.classList.remove("disabled");
    },

    /**
     * カートに商品を追加した後に実行する処理
     * @param {button} btn - ボタン
     */
    isBtnEnabled: function(btn) {
      btn.disabled = false;
      btn.classList.remove("disabled");
    }
  }
}

/**
 * YytAfterAddToCart
 * カートに商品を追加した後に実行する処理
 */
function YytAfterAddToCart() {
  const { isFormEnabled, isBtnEnabled } = AfterAddToCartBase();

  return {
    /**
     * カートの個数を変更する
     * @returns {Promise<void>}
     */
    cartCountChange: async function() {
      const targets = document.querySelectorAll("a[href='/cart'] .Header__CartCount");
      if (targets.length === 0) return console.error("カートの個数が存在しません");

      const cartData = await GetCartDataAPI();
      if (cartData.status !== 200) return console.error("カートのデータが存在しません");
      const data = await cartData.json();
      targets.forEach((target) => {
        target.textContent = data.item_count;
      });
    },

    /**
     * カートに商品を追加した後に実行する処理（アニメーション終了）
     * @param {button} btn - ボタン
     */
    animationEnd: function(btn) {
      if (!btn) return console.error("btn が存在しません");

      btn.innerHTML = "<span>追加しました</span>";
      setTimeout(() => {
        btn.innerHTML = "<span>カートに追加する</span>";
      }, 1800);
    },

    /**
     * エラーが発生した後に実行する処理
     * @param {button} btn - ボタン
     */
    errorAnimationEnd: function(btn) {
      if (!btn) return console.error("btn が存在しません");

      btn.innerHTML = "<span>追加できませんでした</span>";
      setTimeout(() => {
        btn.innerHTML = "<span>カートに追加する</span>";
      }, 1800);
    },

    isFormEnabled,
    isBtnEnabled
  }
}
